/*
 * Form File Upload
 */
import { Component, registerComponent } from 'js/component.js';
const componentName = 'file-upload';

export class FormFileUpload extends Component {

    /**
     * Component Setup
     */
    // Elements
    elements = {
        parentForm: this.element.closest('form'),
        container: this.element.querySelector(`.${componentName}__container`),
        statusContainer: this.element.querySelector(`.${componentName}__status`),
        uploadLabel: this.element.querySelector('label'),
        uploadInput: this.element.querySelector('input[type="file"]'),
        pillsContainer: this.element.querySelector(`.${componentName}__pills`),
        allPills: () => this.element.querySelectorAll(`.${componentName}__pill`)
    };

    // Util & State
    customFileList = null;
    totalFiles = 0;
    isRequired = this.elements.container.getAttribute('data-required');

    emptyLabel = this.elements.container.getAttribute('data-empty-label');
    activeLabel = this.elements.container.getAttribute('data-active-label');

    /**
     * Update Status Labels
     */
    updateStatus = () => {
        this.elements.container.setAttribute('data-total-files', this.totalFiles);

        if(this.totalFiles > 0 && !this.isInvalid) {
            this.elements.statusContainer.innerHTML = `${this.totalFiles} ${this.activeLabel}`;
            if(this.isRequired) this.element.classList.remove('error');
        } else {
            this.elements.statusContainer.innerHTML = this.emptyLabel;
            if(this.isRequired) this.element.classList.add('error');
            this.elements.uploadInput.value = '';
        }
    };

    /**
     * Update Pills
     */
    updatePills = () => {
        if(this.totalFiles > 0 && !this.isInvalid) {
            this.elements.pillsContainer.classList.add('active');
        } else {
            this.elements.pillsContainer.classList.remove('active');
        }

        const onPillClick = (e) => {
            e.preventDefault();
            const currentPill = e.currentTarget;
            const pillName = currentPill.getAttribute('data-filename');

            currentPill.removeEventListener('click', onPillClick);
            this.elements.pillsContainer.removeChild(currentPill);

            [...this.customFileList].map((item, index) => {
                if(item.name === pillName) this.customFileList.splice(index, 1);
                this.totalFiles = this.customFileList.length;

                if(this.totalFiles <= 0 || this.isInvalid) {
                    this.elements.pillsContainer.classList.remove('active');
                    this.elements.uploadInput.value = '';
                }

                this.updateStatus();

                return true;
            });
        };

        const createPill = (fileName) => {
            const newPillEle = document.createElement('button');
            newPillEle.classList.add(`${componentName}__pill`);
            newPillEle.setAttribute('data-filename', fileName);
            newPillEle.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-labelledby="closeTitle closeDesc" role="img"><title id="closeTitle">Close</title><desc id="closeDesc">Close</desc><path d="M4.83 27.141c.339.343.939.342 1.276.001l9.889-9.835 9.898 9.826c.17.172.396.265.639.265s.469-.093.638-.264a.896.896 0 0 0 .264-.638.896.896 0 0 0-.264-.638l-9.9-9.827 9.9-9.89a.903.903 0 0 0 0-1.276.905.905 0 0 0-1.276 0l-9.9 9.89-9.888-9.89a.896.896 0 0 0-.638-.263.905.905 0 0 0-.637 1.541l9.887 9.888-9.888 9.835a.903.903 0 0 0 0 1.275z"/></svg>
                ${fileName}
            `;
            newPillEle.addEventListener('click', onPillClick);
            this.elements.pillsContainer.appendChild(newPillEle);
        };

        // Remove Current Pills
        const allPillEles = this.elements.allPills();
        [...allPillEles].map((ele) => {
            ele.removeEventListener('click', onPillClick);
            return this.elements.pillsContainer.removeChild(ele);
        });

        // Add New Pills
        if(this.customFileList) [...this.customFileList].map((file) => createPill(file.name));
        this.updateStatus();
    };

    /**
     * Add Event Listeners
     */
    addEventListeners = () => {
        const scope = this;

        function onUploadInputChange() {
            let isInvalid = false;

            // Check for valid zip files
            [...this.files].map((file) => {
                if (file.type
                    && (!(/application\/(x-zip-compressed|zip|pdf|msword|vnd\.ms-powerpoint|vnd\.ms-excel|vnd\.openxmlformats)/.test(file.type))
                    || file.size > 5242880)) isInvalid = true;
                return true;
            });
            scope.isInvalid = isInvalid;
            const errorEle = document.getElementsByClassName('file-upload__error-text')[0];

            if(!isInvalid) {
                errorEle.style.display = 'none';
                scope.customFileList = Array.from(this.files);
                scope.totalFiles = this.files.length;

                window.dispatchEvent(new CustomEvent('file-upload-data', {
                    detail: { customFileList: scope.customFileList }
                }));
            } else {
                errorEle.style.display = 'block';
            }

            scope.updatePills();
        }

        this.elements.uploadInput.addEventListener('change', onUploadInputChange, false);
        this.elements.uploadLabel.addEventListener('click', () => this.elements.uploadInput.click());
    };

    /**
     * Initialize Component
     */
    init() {
        // Ensure we have a parent form element
        if(!this.elements.parentForm) return;

        // Init funcs
        this.addEventListeners();
    }
}

registerComponent(`.${componentName}`, FormFileUpload);
